import * as React from 'react';
import { sortableElement } from 'react-sortable-hoc';

const DraggableRow = sortableElement(({ children }) => children);

const PlanningLibraryRow = ({ index, children, ...props }) => (
  <DraggableRow index={index}>
    <div {...props}>{children}</div>
  </DraggableRow>
);

export default PlanningLibraryRow;
